import { FC, useState } from "react";

import PanelLayout, { IPanelLayoutProps } from "components/ui/Panel/PanelLayout";
import PanelBlock from "components/ui/Panel/PanelBlock";
import FileUploadButton from "components/FileUploadButton";

import { TemporaryDocumentType } from "tempDocuments/types";
import LoadingRulesModal from "components/modals/LoadingRulesModal/LoadingRulesModal";
import InfoNotification from "components/ImportMaster/utils/InfoNotification/InfoNotification";

interface IImportExcelProps { }

const ImportExcel: FC<IImportExcelProps> = () => {
  const [isOpenModal, setOpenModal] = useState<boolean>(false);
  const [uploadFileData, setUploadFileData] = useState<TemporaryDocumentType>(null);

  const handleOpenModal = (): void => setOpenModal(true);

  const handleCancelModal = (): void => setOpenModal(false);

  const PANEL_LAYOUT_PROPS: IPanelLayoutProps = {
    title: { content: "Импорт таблицы Excel", size: "large" },
    description: {
      content: <>Добавьте товары, используя прейскурант в Excel (XLS, CSV),
        после успешной загрузки он появится в списке задач по импорту.</>,
      notification: <InfoNotification handleOpenModal={handleOpenModal} />,
    },
    className: "flex"
  };

  return (
   <>
      <PanelLayout {...PANEL_LAYOUT_PROPS}>
        <PanelBlock title={{ content: "Загрузка файла", isRequired: true }}>
          <FileUploadButton
            acceptType=".xls, .xlsx, .csv"
            setUploadedFileData={setUploadFileData}
            description="Формат: XLS, CSV"
          />
        </PanelBlock>
      </PanelLayout>
     <LoadingRulesModal
        isOpen={isOpenModal}
        onCancelHandler={handleCancelModal}
        variant="excel"
     />
   </>
  );
};

export default ImportExcel;